export default __webpack_public_path__ + "static/media/Swiss-Lemon.c642b44d.jpg";